import { render } from "./newsList.vue?vue&type=template&id=095911b6&scoped=true"
import script from "./newsList.vue?vue&type=script&lang=js"
export * from "./newsList.vue?vue&type=script&lang=js"

import "./newsList.vue?vue&type=style&index=0&id=095911b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-095911b6"]])

export default __exports__